export default class BlockConditionalDisplay {
    constructor(container, options) {
        const defaultOptions = {
            condition: '.condition',
            defaultCondition: '.condition.default'
        };
        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);
        this.conditions = this.container.querySelectorAll(this.options.condition);
        this.defaultCondition = this.container.querySelector(this.options.defaultCondition);
        this.geoData = localStorage.getItem('geo');
        this.dateNow = new Date();
        this.activeCondition = null;

        this.onLoad();
    }

    onLoad() {
        this.conditions.forEach(elem => {
            if(this.activeCondition === null && this.isActive(elem)) {
                this.activeCondition = elem;
                this.activeCondition.classList.add('active');
            }
        });

        if (!this.activeCondition) {
            if (this.defaultCondition !== null) {
                this.defaultCondition.classList.add('active')
            } else {
                console.warn('default condition not set')
            }
        }
    }

    isActive(elem) {
        let active = true;
        let startDate = elem.dataset.startDate;
        let endDate = elem.dataset.endDate;
        let startTime = elem.dataset.startTime;
        let endTime = elem.dataset.endTime;
        let countries = elem.dataset.countries;
        let regions = elem.dataset.regions;

        if (typeof startDate === 'undefined' || typeof endDate === 'undefined') {
            return false;
        }

        let ticks = this.dateNow.getTime()
        let startDateTime = new Date(startDate)
        let endDateTime = new Date(endDate)

        if (typeof startTime !== 'undefined') {
            const [startHour, startMinute, startSecond] = startTime.split(':')
            startDateTime.setHours(parseInt(startHour, 10))
            startDateTime.setMinutes(parseInt(startMinute, 10))
            startDateTime.setSeconds(parseInt(startSecond, 10))
        } else {
            active = false
        }

        if (typeof endTime !== 'undefined') {
            const [endHour, endMinute, endSecond] = endTime.split(':')
            endDateTime.setHours(parseInt(endHour, 10))
            endDateTime.setMinutes(parseInt(endMinute, 10))
            endDateTime.setSeconds(parseInt(endSecond, 10))
        } else {
            active = false
        }
    
        if (ticks < startDateTime.getTime() || ticks > endDateTime.getTime()) {
            active = false
        }

        if(this.geoData !== null) {
            let geo = JSON.parse(this.geoData)
            if(countries !== '') {
                var countryList = countries.split(',').map(item => item.trim())
                if(countryList.indexOf(geo.countryCode) === -1) {
                    active = false
                }
            }

            if(regions !== '') {
                var regionsList = regions.split(',').map(item => item.trim())
                // TODO need to get the data when its not expired.
                // if(regionsList.indexOf(geo.geo.regionCode) === -1) {
                //     active = false;
                // }
            }
        }

        return active;
    }
}
